import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateProcessPage } from './create-process.page';

const routes: Routes = [
  {
    path: '',
    component: CreateProcessPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateProcessPageRoutingModule {}
